import { useState, useRef, useCallback, useEffect } from 'react';

export const useRecaptcha = () => {
  const [capchaToken, setCapchaToken] = useState('');
  const recaptchaRef = useRef(null);

  const handleRecaptcha = useCallback((token) => {
    setCapchaToken(token || '');
  }, []);

  // Bypass captcha in e2e test environment
  useEffect(() => {
    try {
      if (window.top.__E2E__) {
        // oxlint-disable-next-line react-hooks/set-state-in-effect
        setCapchaToken('e2e-test-token');
      }
    } catch {
      // cross-origin frame access — not in test environment
    }
  }, []);

  useEffect(() => {
    const refreshCaptcha = () => {
      if (recaptchaRef.current && capchaToken) {
        recaptchaRef.current.reset();
        setCapchaToken('');
      }
    };

    let tokenRefreshTimeout = null;

    if (capchaToken) {
      tokenRefreshTimeout = setTimeout(refreshCaptcha, 110000); // 110 seconds
    }

    return () => {
      if (tokenRefreshTimeout) {
        clearTimeout(tokenRefreshTimeout);
      }
    };
  }, [capchaToken]);

  return { capchaToken, setCapchaToken, recaptchaRef, handleRecaptcha };
};

export default useRecaptcha;
